import Pubnub from 'pubnub';
import Channel from '../channel/channel';
import { CueMessageBrokerEvents } from '../constants/event-constants';
import { MAX_RETRY_COUNT } from '../constants/value-constants';
import { getLogger } from '../logger/logger';
class CueMessageBroker {
    pubnubInstance;
    channelMap; // string is the channelId
    retryMap;
    userId;
    logger;
    constructor(options) {
        this.channelMap = {};
        this.retryMap = {};
        this.pubnubInstance = new Pubnub(options);
        this.userId = options.userId;
        this.logger = getLogger(options.logger);
    }
    getPubnubInstance() {
        return this.pubnubInstance;
    }
    async createChannel(options) {
        if (!options.channelId || !options.channelName) {
            throw new Error('Please provide channelId and a unique channel name');
        }
        try {
            let channelInstance = this.channelMap[options.channelId];
            if (channelInstance) {
                channelInstance.addStatusChangeListner(options.onStatusChangeFn);
                channelInstance.addMetadataChangeListner(options.onMetadataChangeFn);
                channelInstance.addConsumer(options.consumerFn);
                options.consumerFn &&
                    !options.noHistory &&
                    channelInstance.initExistingChannel(options.consumerFn);
                return channelInstance;
            }
            channelInstance = new Channel({ ...options, userId: this.userId, logger: options.logger || this.logger }, this.pubnubInstance);
            this.channelMap[options.channelId] = channelInstance;
            await channelInstance.init();
            this.retryMap[options.channelId] = 0;
            return channelInstance;
        }
        catch (e) {
            let retryCount = this.retryMap[options.channelId] || 0;
            const channelInstance = this.channelMap[options.channelId];
            this.logger(CueMessageBrokerEvents.CHANNEL_INIT_FAILED, {
                channelId: options.channelId,
                error: JSON.stringify(e),
                retry: retryCount,
            });
            retryCount++;
            this.retryMap[options.channelId] = retryCount;
            channelInstance?.destroyChannel();
            if (retryCount > MAX_RETRY_COUNT) {
                return channelInstance || null;
            }
            this.channelMap[options.channelId] = null;
            return this.createChannel(options);
        }
    } // get or create
    destroyChannel(channelId) {
        if (this.channelMap[channelId]) {
            this.channelMap[channelId]?.destroyChannel();
        }
    }
    disconnect() {
        Object.keys(this.channelMap).forEach(channelId => {
            this.channelMap[channelId]?.destroyChannel();
        });
    }
}
export default CueMessageBroker;
//# sourceMappingURL=cue-message-broker.js.map